import { render, staticRenderFns } from "./Profissionais.vue?vue&type=template&id=d71b8264"
import script from "./Profissionais.vue?vue&type=script&lang=js"
export * from "./Profissionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports